export default __webpack_public_path__ + "static/media/gowtham.fcfa8cad.jpg";